module.exports = __webpack_public_path__ + "static/media/user_default.b95ae25a.png";